import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { extrairMensagemErroApi } from 'src/app/utils/utils/extrair-mensagem-erro-api';

@Injectable({
  providedIn: 'root',
})
export class SnackbarManager {
  constructor(private snackBar: MatSnackBar) {}

  openSnackBar(message: string, action: string, duration: number) {
    this.snackBar.open(message, action, {
      duration: duration,
      panelClass: ['snackbar-custom-formats'],
    });
  }

  /**
   * Exibe a mensagem de negócio devolvida pela API no corpo do erro, ou `mensagemPadrao`
   * quando o corpo não for uma mensagem exibível (erro técnico, HTML, payload vazio, etc.).
   *
   * Correção do chamado #68659 (revisão de código, alerta 1): os pontos que chamavam
   * `openSnackBar(error.error, ...)` exibiam o corpo cru do erro HTTP no snackbar, sem
   * passar pelas barreiras anti-vazamento que HttpErrorMessageService já aplica no dialog
   * — na prática, o mesmo erro mostrava texto filtrado no dialog e corpo integral (podendo
   * conter stack trace, nome de constraint/tabela ou HTML) no snackbar.
   *
   * Usa a função extraída extrairMensagemErroApi() em vez de injetar HttpErrorMessageService
   * diretamente: esse serviço injeta PedidoManager, que por sua vez injeta SnackbarManager —
   * injetá-lo aqui criaria dependência circular.
   *
   * Repasse restrito a 400/403 (revisão de código do #68659, alerta 3): apenas nesses status
   * o corpo é comprovadamente produzido por código nosso via Gson. Nos demais (ex.: 500/502/504
   * de um proxy) o corpo vem de infraestrutura, e sem essa restrição poderia coincidir em forma
   * com uma mensagem de negócio válida e vazar para a tela — mesma barreira já aplicada em
   * HttpErrorMessageService.getErrorMessage() para o dialog.
   */
  openSnackBarErro(error: HttpErrorResponse, mensagemPadrao: string, action: string, duration: number) {
    const repassaMensagemApi = error.status === 400 || error.status === 403;
    const mensagem = (repassaMensagemApi ? extrairMensagemErroApi(error) : null) ?? mensagemPadrao;

    this.openSnackBar(mensagem, action, duration);
  }

  openSnackBarCustom(message: string, action: string, duration: number) {
    this.snackBar.open(message, action, {
      duration: duration,
      verticalPosition: 'top',
      panelClass: ['preco-divergente', 'snackbar-custom-formats'],
    });
  }
}
